import { Card, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import React, { useEffect, useState } from 'react';
import { useRecordContext, useTranslate } from 'react-admin';
import InfoTooltipIcon from '../../../assets/InfoTooltipIcon';
import globalUseStyles from '../../../styles/globalCustomStyles';
import ExportButton from '../../Buttons/ExportButton';
import { allowedShowComponents, useRolePermissions } from "../../aegeon-rbac/AuthRolePermissions";
import CustomTooltip from '../../aegeon/CustomTooltip';
import AnalysisCardDetails from '../../aegeon/cards/AnalysisCardDetails';
import DetailsShow from '../../aegeon/cards/DetailsShow';
import { export_row_to_excel } from '../../aegeon/helper';

import DataComparisonAnalysisCardDetails from './DataComparisonAnalysisCardDetails';
import PotentialGainDeviceDetails from './PotentialGainDeviceDetails';

const AnalysisTextDetails = (props) => {
  const t = useTranslate();
  const globalClasses = globalUseStyles();
  const record = useRecordContext();
  const { isLoading: isLoadingPermissions, permissions } = useRolePermissions();
  const isEnedis = ["enedisMeter"].includes(record?.deviceType);

  const setDataCallback = (childData) => {
    if (childData && !props.dataAnalysis) {
      props.setDataAnalysis(childData)
    }
  }

  const permissionControlledComponentsIndex = isEnedis && {
    resource: "devices",
    elements: {
      show: {
        "analyse.comparison":
          <Grid2 item="true" small={12} medium={6} big={6} key="2">
            <Card className={globalClasses.DetailCard}>
              <div className={globalClasses.DetailCardTableTitle}>
                <Typography variant="h8">{t('devices.analyse.comparison.title')}</Typography>
                <CustomTooltip title={t('devices.analyse.comparison.tooltip_text')} icon={<InfoTooltipIcon />} />
              </div>
              <div className={globalClasses.DetailCardTableSubtitle}>
                {t('devices.analyse.comparison.subtitle')}
              </div>
              <div className={globalClasses.DetailCardGraphDouble}>
                <DataComparisonAnalysisCardDetails />
              </div>
            </Card>
          </Grid2>
      }
    }
  };

  const permissionControlledComponentsPotentialGain = isEnedis && {
    resource: "devices",
    elements: {
      show: {
        "analyse.potential_gain": <PotentialGainDeviceDetails key="3" />
      }
    }
  };

  let cardSize = !isEnedis || (!isLoadingPermissions && allowedShowComponents(permissions, permissionControlledComponentsIndex).length === 0) ? 12 : 6;

  return (
    <div>
      <Grid2 container spacing={2}>
        <Grid2 item="true" small={12} medium={cardSize} big={cardSize} key="1">
          <Card className={globalClasses.DetailCard}>
            <AnalysisCardDetails analysisClass="DEVICE" analysisType="METER_COMMISSIONING" setDataCallback={setDataCallback} />
          </Card>
        </Grid2>
        {!isLoadingPermissions && allowedShowComponents(permissions, permissionControlledComponentsIndex)}
        {!isLoadingPermissions && allowedShowComponents(permissions, permissionControlledComponentsPotentialGain)}
      </Grid2>
    </div>
  )
};


const AnalysisTextDetailsWithContext = (props) => {
  const t = useTranslate();
  const title = t('devices.analyse.title');
  const [dataAnalysis, setDataAnalysis] = useState();
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    if (dataAnalysis !== undefined) {
      setDisabled(false)
    }
  }, [dataAnalysis])

  const handleExport = (name) => {
    var sheets_data = [];
    if (dataAnalysis !== null) {
      dataAnalysis.map((item, index) => {
        const date = new Date(item.created_at).toLocaleDateString(localStorage.getItem("language"), { year: 'numeric', month: 'long', day: 'numeric' })
        sheets_data.push({ sheetName: index + " - " + date, data: [["Date de l'analyse", date], ["Résultat de l'analyse", item.text]] });
      }
      )
      export_row_to_excel(sheets_data, `${t('resources.analyse.export_name')}${name}.xlsx`);
    };
  };
  return (
    <DetailsShow title={title} resource="devices" lessMargin={true} tooltip={<ExportButton onClick={handleExport} disabled={disabled} />} >
      <AnalysisTextDetails setDataAnalysis={setDataAnalysis} dataAnalysis={dataAnalysis} {...props} />
    </DetailsShow>
  )
}

export default AnalysisTextDetailsWithContext;

